module.exports = __webpack_public_path__ + "static/media/benefit.57d3382b.gif";